import React, { useContext } from "react";

// Global state
import { StateContext } from "../../AppStateContext.js";

// Material UI imports
import TableCell from "@material-ui/core/TableCell";

const AddClassPropertiesTableCell = ({ text, align }) => {
  // To consume global state
  const state = useContext(StateContext);
  return (
    <TableCell
      component="th"
      scope="row"
      align={align}
      className={
        state.theme === "dark"
          ? "__addClassPropertyTableBodyCell __addClassPropertyTableBodyCellDark"
          : "__addClassPropertyTableBodyCell __addClassPropertyTableBodyCellLight"
      }
      style={{
        background: "transparent",
        borderBottom:
          state.theme === "dark"
            ? "0.1px solid #213957"
            : "0.1px solid #d5eaff",
      }}
    >
      {text}
    </TableCell>
  );
};

export default AddClassPropertiesTableCell;
